import ArrayVisualizer from './components/ArrayVisualizer/ArrayVisualizer';

function App() {
	return (
		<div>
			<ArrayVisualizer />
		</div>
	);
}

export default App;
